const DEFAULT_WINDOW_TITLE = 'CNTNDR | Beat Battles & Music Competitions | Showcase Your Talent';
export const updateDocumentTitle = (title = '') => {
    window.document.title = title || DEFAULT_WINDOW_TITLE;
}

export const capitalizeFirstLetter = string => {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export const scrollToTop = () => {
    window.scrollTo({
        top: 0,
        left: 0,
        behavior: "instant",
    });
}